import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import prism from 'prismjs';
import 'prismjs/components/prism-css.js';
import 'prismjs/components/prism-bash.js';
import 'prismjs/components/prism-diff.js';
import 'prismjs/components/prism-javascript.js';
import 'prismjs/components/prism-json.js';
import 'prismjs/components/prism-jsx.js';
import 'prismjs/components/prism-markup.js';
import 'prismjs/components/prism-yaml.js';
import 'prismjs/components/prism-tsx.js';
function highlight(code, language) {
  var prismLanguage;
  switch (language) {
    case 'ts':
      prismLanguage = prism.languages.tsx;
      break;
    case 'js':
      prismLanguage = prism.languages.jsx;
      break;
    case 'sh':
      throw new Error(["docs-infra: Unsupported language: \"sh\" in:", '', '```sh', code, '```', '', 'Use "bash" instead.', ''].join('\n'));
    case 'diff':
      prismLanguage = _extends({}, prism.languages.diff);
      // original `/^[-<].*$/m` matches lines starting with `<` which matches
      // <SomeComponent />
      // we will only use `-` as the deleted marker
      prismLanguage.deleted = /^[-].*$/m;
      break;
    default:
      prismLanguage = prism.languages[language];
      break;
  }
  if (!prismLanguage) {
    if (language) {
      throw new Error("unsupported language: \"".concat(language, "\", \"").concat(code, "\""));
    } else {
      prismLanguage = prism.languages.jsx;
    }
  }
  return prism.highlight(code, prismLanguage);
}
export default highlight;